module.exports = __webpack_public_path__ + "static/media/share.df5072e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/share.jpg
// module id = 282
// module chunks = 0